import api from './api';

const budgetPlanningService = {
  getAllBudgetPlannings: async (params = {}) => {
    try {
      const response = await api.get('/budget-plannings', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching budget plannings:', error);
      throw error;
    }
  },

  getBudgetPlanningById: async (id) => {
    try {
      const response = await api.get(`/budget-plannings/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching budget planning with ID ${id}:`, error);
      throw error;
    }
  },

  createBudgetPlanning: async (budgetPlanningData) => {
    try {
      const response = await api.post('/budget-plannings', budgetPlanningData);
      return response.data;
    } catch (error) {
      console.error('Error creating budget planning:', error);
      throw error;
    }
  },

  updateBudgetPlanning: async (id, budgetPlanningData) => {
    try {
      const response = await api.put(`/budget-plannings/${id}`, budgetPlanningData);
      return response.data;
    } catch (error) {
      console.error(`Error updating budget planning with ID ${id}:`, error);
      throw error;
    }
  },

  deleteBudgetPlanning: async (id) => {
    try {
      const response = await api.delete(`/budget-plannings/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting budget planning with ID ${id}:`, error);
      throw error;
    }
  },

  getBudgetPlanningStats: async () => {
    try {
      const response = await api.get('/budget-plannings/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching budget planning stats:', error);
      throw error;
    }
  }
};

export default budgetPlanningService;

